<template>
  <popup
    class="rb-popup-exit"
    title="Exit"
    :active="active"
    :on-screen="onScreen"
    @close="close"
  >
    <div class="rb-center">
      <h2>Are you sure you want to exit?</h2>
      <div class="rb-btns">
        <button
          aria-label="Keep Designing"
          class="rb-btn rb-btn-close"
          @click.prevent="notifyKeepDesigning"
          id="btn-keep-designing"
        >
          Keep Designing
        </button>
        <button
          aria-label="Exit Builder"
          class="rb-btn rb-btn-exit"
          @click.prevent="notifyEndRingBuilder"
          id="btn-exit-builder"
        >
          Yes, Exit Builder
        </button>
      </div>
    </div>
  </popup>
</template>

<script>
/**
 * Exit Popup
 *
 * @implements
 * PopupMixin
 * CommMixin
 * TrackMixin
 *
 * @props
 * data: Object
 */
import Popup from "@/components/Popup";
import PopupMixin from "@/mixins/PopupMixin";
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
export default {
  components: {
    Popup,
  },
  mixins: [PopupMixin, CommMixin, TrackMixin],
  methods: {
    notifyKeepDesigning: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.close();
    },
    notifyEndRingBuilder: function (event) {
      this.close();
      this.broadcast("rb-end-builder");
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
  },
};
</script>
